module.exports = __webpack_public_path__ + "img/web_cover.3dd6a8ce.jpg";